import Constants from "~/helpers/enums/Constants";

const initialState = {
	search: null,
};

const searchReducer = (state = initialState, action = null) => {
	switch (action.type) {
		case Constants.GET_SEARCH:
			return {
				...state,
				search: action.payload.search,
			};
		default:
			return state;
	}
};

export default searchReducer;
